import React, { FC, useEffect, useState } from "react"
import ReactDOM from "react-dom"

import { isClientSide } from "@utils"
import { ICON_TYPES } from "@components/Icon/Icon.constants"
import Icon from "@components/Icon/Icon"

import "./PnpPlayer.scss"

type PnpPlayerProps = {
  children: React.ReactNode,
  onClose: () => void,
}

const PnpPlayer: FC<PnpPlayerProps> = ({
  children,
  onClose,
}) => {
  const [pnpEl, setPnpEl] = useState<HTMLDivElement | null>(null)

  useEffect(() => {
    if (!isClientSide()) return

    const _pnpEl = document.createElement("div")

    setPnpEl(_pnpEl)
    document.body.append(_pnpEl)

    const onKeyUp = (e: KeyboardEvent) => {
      // If the `esc` key is pressed:
      if (e.which === 27) onClose()
    }

    window.addEventListener("keyup", onKeyUp)

    return () => {
      document.body.removeChild(_pnpEl)
      setPnpEl(null)
      window.removeEventListener("keyup", onKeyUp)
    }
  }, [])

  return pnpEl ? ReactDOM.createPortal(
    <div className="PnpPlayer">
      <button
        className="close-button"
        onClick={onClose}
      >
        <Icon
          color="var(--color--action-default)"
          size="20px"
          type={ICON_TYPES.close}
        />
      </button>
      <div>
        {children}
      </div>
    </div>
    , pnpEl
  ) : null
}

export default PnpPlayer
